module.exports = __webpack_public_path__ + "images/emoji/arrow_right.5759711ecc8acb2e90a5.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/arrow_right.png
// module id = Ljjr
// module chunks = 2